var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:("kalendarEventRef-" + (_vm.event.id)),staticClass:"event-card",class:{
      'is-past': false,
    'overlaps': _vm.overlaps > 0,
    'two-in-one': _vm.total > 1,
    'inspecting': !!_vm.inspecting,
    'event-card__mini': _vm.event.distance <= 10,
    'event-card__small': (_vm.event.distance > 10 && _vm.event.distance < 40) || (_vm.overlaps > 1)
  },style:(("\n    height: " + _vm.distance + ";\n    width: calc(" + _vm.width_value + ");\n    left: calc(" + _vm.left_offset + ");\n    top: " + _vm.top_offset + ";\n  ")),on:{"click":function($event){_vm.inspecting = true},"mouseleave":function($event){_vm.inspecting = false}}},[_c('portal-target',{attrs:{"name":"event-details","slot-props":_vm.information,"slim":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }